module.exports = __webpack_public_path__ + "img/level-well.52ecb13f.png";